import React from "react";

import { ResponsiveAccordion } from "./ResponsiveAccordion";
import { useFooterClickEventTracker } from "./useFooterClickEventTracker";

export const AboutLeafly = () => {
  const { createPublishFooterClickEventFunction } =
    useFooterClickEventTracker();

  return (
    <ResponsiveAccordion
      label="About Leafly"
      ariaControlsName="nav__about"
      defaultExpanded={false}
    >
      <ul className="text-sm text-green font-bold" id="nav__about">
        <li className="py-sm">
          <a
            href="/info/about"
            onClick={createPublishFooterClickEventFunction("about us")}
          >
            About us
          </a>
        </li>
        <li className="py-sm">
          <a
            href="/info/jobs"
            onClick={createPublishFooterClickEventFunction("careers")}
          >
            Careers
          </a>
        </li>
        <li className="py-sm">
          <a
            href="https://www.leafly.com/newsroom"
            onClick={createPublishFooterClickEventFunction("newsroom")}
          >
            Newsroom
          </a>
        </li>
        <li className="py-sm">
          <a
            href="https://investor.leafly.com"
            onClick={createPublishFooterClickEventFunction(
              "investor relations"
            )}
          >
            {" "}
            Investor relations
          </a>
        </li>
        <li className="py-sm">
          <a
            href="/info/contact"
            onClick={createPublishFooterClickEventFunction("contact us")}
          >
            Contact us
          </a>
        </li>
        <li className="py-sm">
          <a
            href="https://help.leafly.com"
            onClick={createPublishFooterClickEventFunction("faqs")}
          >
            FAQs
          </a>
        </li>
        <li className="py-sm mr-md">
          <a
            href="/info/accessibility"
            onClick={createPublishFooterClickEventFunction("accessibility")}
          >
            Accessibility
          </a>
        </li>
      </ul>
    </ResponsiveAccordion>
  );
};
